<template>
  <div v-if="!isClosed" class="body-header d-flex justify-content-around banner mb-4">
    <div class="pt-3">
      <h2 class="banner__title">Giải pháp chấm công thông minh</h2>
      <p class="banner__subtitle pt-3 pb-3">
        Quản lý chấm công cho doanh nghiệp đơn giản và hiệu quả
      </p>
      <el-button class="btn-access btn-radius-25" @click="fn_go()"
        >Truy cập ngay</el-button
      >
    </div>
    <img
      style="z-index: 2"
      src="../../../../public/img/illustrator-timekeeping.png"
      alt="banner-picture"
    />
    <img class="banner__footer" src="../../../../public/img/detail-banner.png" alt="">
    <i class="el-icon-close" @click="fn_closeBanner"></i>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isClosed: false,
    }
  },
  methods: {
    fn_closeBanner() {
      this.isClosed = !this.isClosed;
      sessionStorage.setItem('bannerColsed', true);
    }
  },
  created() {
    let checkClose = sessionStorage.getItem('bannerColsed');
    if (checkClose) {
      this.isClosed = true;
    }
  },
};
</script>

<style scoped>
.banner {
  border-radius: 10px;
  background:
    linear-gradient(178.18deg, #f7a364 -13.56%, #f07f7d 158.3%);
  margin: auto;
  padding: 10px !important;
  position: relative;
}
.banner .banner__title {
  font-size: 30px;
  text-transform: uppercase;
  color: #fff;
}
.banner .banner__subtitle {
  font-size: 18px;
  font-weight: 200;
  color: #fff;
}
.banner__footer {
  position: absolute;
  bottom: 0px;
  left: 0;
  z-index: 0;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
.banner .btn-access {
  border: 1px solid #fff;
  background: #fff;
  color: var(--orange);
  font-size: 12px;
  font-weight: 700;
  text-transform: none;
  padding: 10px 15px 10px 15px;
  transition: 0.3s ease;
}
.banner .btn-access:hover,
.banner .btn-access:active {
  color: #fff;
  background: #ffb482 !important;
}
.banner .el-icon-close {
  position: absolute;
  top: 10%;
  right: 5%;
  color: #fff;
  cursor: pointer;
  z-index: 3;
}
@media (max-width:1180px) {
  .banner .banner__title {
    font-size: 20px;
  }
  .banner .banner__subtitle {
    font-size: 15px;
  }
  .banner .btn-access {
    padding: 8px 10px 8px 10px;
  }
}
</style>
